import { createSlice } from '@reduxjs/toolkit'
import { redirectToLogin } from './localStorage'

const initialState = {
  loading: 0,
  token: '',
  userDetails: {},
  companyDetails: {},
  rememberData: { email_id: '', password: '' },
  systemSettings: {},
}

const appSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    showLoader: () => {},
    setLoginToken: (state, { payload }) => {
      state.token = payload
    },
    setUserDetails: (state, { payload }) => {
      state.userDetails = { ...payload }
    },
    setCompanyDetails: (state, { payload }) => {
      state.companyDetails = { ...payload }
    },
    setRemember: (state, { payload }) => {
      state.rememberData = { ...payload }
    },
    setSystemSettings: (state, { payload }) => {
      state.systemSettings = { ...payload }
    },
    logout: (state: any) => {
      state.loading = false
      state.token = ''
      redirectToLogin()
    },
  },
})

export const {
  showLoader,
  setLoginToken,
  setUserDetails,
  setCompanyDetails,
  setRemember,
  setSystemSettings,
  logout,
} = appSlice.actions

export default appSlice.reducer
